import { AdSizeBean, AdSizeControllerApi, ItemResponseAdSizeBeanObject, ListResponseAdSizeBean } from 'src/api/api'
import { BaseApi, configuration } from '../../../api/BaseApi'

class AdSizeApi extends BaseApi {
    api: AdSizeControllerApi

    constructor() {
        super()
        this.api = new AdSizeControllerApi(configuration, configuration.basePath, this.fetch)
    }

    list(size: number = 20, page: number = 1, sort, search): Promise<ListResponseAdSizeBean> {
        return this.call(() => this.api.adSizeList(search, { query: { size, page, sort } }))
    }

    all(): Promise<ListResponseAdSizeBean> {
        return this.call(() => this.api.adSizeList())
    }

    create(adSize: AdSizeBean): Promise<ItemResponseAdSizeBeanObject> {
        return this.call(() => this.api.createAdSize(adSize))
    }

    edit(id: any, adSize: AdSizeBean): Promise<ItemResponseAdSizeBeanObject> {
        return this.call(() => this.api.editAdSize(adSize, id))
    }

    view(id: any): Promise<ItemResponseAdSizeBeanObject> {
        return this.call(() => this.api.adSize(id))
    }

    delete(id: any): Promise<void> {
        return this.call(() => this.api.deleteAdSize(id))
    }
}

const adSizeApi = new AdSizeApi()
export default adSizeApi


// WEBPACK FOOTER //
// ./src/component/app/adSize/AdSizeApi.ts